var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.25C8.66421 9.25 9 9.58579 9 10V19C9 19.4142 8.66421 19.75 8.25 19.75C7.83579 19.75 7.5 19.4142 7.5 19V10C7.5 9.58579 7.83579 9.25 8.25 9.25Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.25C12.4142 9.25 12.75 9.58579 12.75 10V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V10C11.25 9.58579 11.5858 9.25 12 9.25Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10C16.5 9.58579 16.1642 9.25 15.75 9.25C15.3358 9.25 15 9.58579 15 10V19C15 19.4142 15.3358 19.75 15.75 19.75C16.1642 19.75 16.5 19.4142 16.5 19V10Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 5.5C21.75 6.32843 21.0784 7 20.25 7H19.5V20.5C19.5 22.1569 18.1569 23.5 16.5 23.5H7.5C5.84315 23.5 4.5 22.1569 4.5 20.5V7H3.75C2.92157 7 2.25 6.32843 2.25 5.5V4C2.25 3.17157 2.92157 2.5 3.75 2.5H9C9 1.67157 9.67157 1 10.5 1H13.5C14.3284 1 15 1.67157 15 2.5H20.25C21.0784 2.5 21.75 3.17157 21.75 4V5.5ZM6.17705 7L6 7.08853V20.5C6 21.3284 6.67157 22 7.5 22H16.5C17.3284 22 18 21.3284 18 20.5V7.08853L17.8229 7H6.17705ZM3.75 5.5H20.25V4H3.75V5.5Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.25C8.66421 9.25 9 9.58579 9 10V19C9 19.4142 8.66421 19.75 8.25 19.75C7.83579 19.75 7.5 19.4142 7.5 19V10C7.5 9.58579 7.83579 9.25 8.25 9.25Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.25C12.4142 9.25 12.75 9.58579 12.75 10V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V10C11.25 9.58579 11.5858 9.25 12 9.25Z",
    fill: "#585858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10C16.5 9.58579 16.1642 9.25 15.75 9.25C15.3358 9.25 15 9.58579 15 10V19C15 19.4142 15.3358 19.75 15.75 19.75C16.1642 19.75 16.5 19.4142 16.5 19V10Z",
    fill: "#585858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 5.5C21.75 6.32843 21.0784 7 20.25 7H19.5V20.5C19.5 22.1569 18.1569 23.5 16.5 23.5H7.5C5.84315 23.5 4.5 22.1569 4.5 20.5V7H3.75C2.92157 7 2.25 6.32843 2.25 5.5V4C2.25 3.17157 2.92157 2.5 3.75 2.5H9C9 1.67157 9.67157 1 10.5 1H13.5C14.3284 1 15 1.67157 15 2.5H20.25C21.0784 2.5 21.75 3.17157 21.75 4V5.5ZM6.17705 7L6 7.08853V20.5C6 21.3284 6.67157 22 7.5 22H16.5C17.3284 22 18 21.3284 18 20.5V7.08853L17.8229 7H6.17705ZM3.75 5.5H20.25V4H3.75V5.5Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeTrash);
export default __webpack_public_path__ + "static/media/loree-trash.bc7d844385c7e7081624a50666b6f2a3.svg";
export { ForwardRef as ReactComponent };